import { OpsLayout } from '@/components/ops/OpsLayout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { FhirDataFlowPanel } from '@/components/admin/sandbox/FhirDataFlowPanel';
import { SecurityAuditPanel } from '@/components/admin/sandbox/SecurityAuditPanel';
import { SafetyValvePanel } from '@/components/admin/sandbox/SafetyValvePanel';
import { Server, ShieldAlert, ToggleRight } from 'lucide-react';

export default function IntegrationSandboxPage() {
  return (
    <OpsLayout>
      <div className="p-6 space-y-6 max-w-7xl mx-auto">
        <div>
          <h1 className="text-2xl font-bold flex items-center gap-2">
            <Server className="w-6 h-6 text-primary" />
            Integration Sandbox
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            Hospital IT — FHIR Data Flow, Security Posture & Export Controls
          </p>
        </div>

        <Tabs defaultValue="dataflow" className="space-y-4">
          <TabsList className="grid w-full grid-cols-3 h-auto">
            <TabsTrigger value="dataflow" className="flex items-center gap-1.5 text-xs sm:text-sm py-2">
              <Server className="w-3.5 h-3.5" />
              Clean-Room Export
            </TabsTrigger>
            <TabsTrigger value="security" className="flex items-center gap-1.5 text-xs sm:text-sm py-2">
              <ShieldAlert className="w-3.5 h-3.5" />
              Security Audit
            </TabsTrigger>
            <TabsTrigger value="safety" className="flex items-center gap-1.5 text-xs sm:text-sm py-2">
              <ToggleRight className="w-3.5 h-3.5" />
              Safety Valve
            </TabsTrigger>
          </TabsList>

          <TabsContent value="dataflow"><FhirDataFlowPanel /></TabsContent>
          <TabsContent value="security"><SecurityAuditPanel /></TabsContent>
          <TabsContent value="safety"><SafetyValvePanel /></TabsContent>
        </Tabs>
      </div>
    </OpsLayout>
  );
}
